import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource-variable/inter";
import "@fontsource/nova-square";
import "@fontsource-variable/jetbrains-mono";
import App from "./App";
import "./styles.css";
import "./wiki-theme.css";

const root = document.getElementById("root");
if (root === null) {
    throw new Error("Application root element is missing.");
}

createRoot(root).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
